import axiosClient from './axiosClient';
import categoriesApi from './categoriesApi';
import createFormData from './formData';

const multipartConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const hasUpload = (payload = {}) => {
  return Object.values(payload).some((value) => {
    return value instanceof File || value instanceof Blob;
  });
};

const normalizeBoolean = (value) => {
  if (value === true || value === 1 || value === '1') {
    return 1;
  }

  return 0;
};

const cleanPayload = (payload = {}) => {
  const normalized = {
    ...payload,
  };

  [
    'business_id',
    'owner_id',
    'menu_template_id',
  ].forEach((key) => {
    if (normalized[key] === '') {
      normalized[key] = null;
    }
  });

  [
    'is_active',
    'ordering_enabled',
    'allow_comments',
    'allow_ratings',
    'allow_likes',
  ].forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(normalized, key)) {
      normalized[key] = normalizeBoolean(normalized[key]);
    }
  });

  if (!normalized.type) {
    normalized.type = 'restaurant';
  }

  if (!normalized.default_language) {
    normalized.default_language = 'fr';
  }

  return normalized;
};

export const establishmentsApi = {
  getEstablishments(params = {}) {
    return axiosClient.get('/establishments', {
      params,
    });
  },

  getEstablishment(establishmentId) {
    return axiosClient.get(`/establishments/${establishmentId}`);
  },

  createEstablishment(payload = {}) {
    const normalizedPayload = cleanPayload(payload);

    if (hasUpload(normalizedPayload)) {
      return axiosClient.post(
        '/establishments',
        createFormData(normalizedPayload),
        multipartConfig,
      );
    }

    return axiosClient.post('/establishments', normalizedPayload);
  },

  updateEstablishment(establishmentId, payload = {}) {
    const normalizedPayload = cleanPayload(payload);

    if (hasUpload(normalizedPayload)) {
      return axiosClient.post(
        `/establishments/${establishmentId}`,
        createFormData({
          ...normalizedPayload,
          _method: 'PATCH',
        }),
        multipartConfig,
      );
    }

    return axiosClient.patch(
      `/establishments/${establishmentId}`,
      normalizedPayload,
    );
  },

  updateStatus(establishmentId, isActive) {
    return axiosClient.patch(
      `/establishments/${establishmentId}/status`,
      {
        is_active: normalizeBoolean(isActive),
      },
    );
  },

  deleteEstablishment(establishmentId) {
    return axiosClient.delete(`/establishments/${establishmentId}`);
  },

  getCategories(establishmentId, params = {}) {
    return categoriesApi.getCategories(
      establishmentId,
      params,
    );
  },

  getActiveCategories(establishmentId, params = {}) {
    return categoriesApi.getActiveCategories(
      establishmentId,
      params,
    );
  },

  getParentCategories(establishmentId, params = {}) {
    return categoriesApi.getParentCategories(
      establishmentId,
      params,
    );
  },

  getSubcategories(
    establishmentId,
    parentId,
    params = {},
  ) {
    return categoriesApi.getSubcategories(
      establishmentId,
      parentId,
      params,
    );
  },

  getCategoryTree(establishmentId, params = {}) {
    return categoriesApi.getCategoryTree(
      establishmentId,
      params,
    );
  },
};

export { categoriesApi };

export default establishmentsApi;